{
  "conversation": {
    "agent_mode": {
      "saved": "Vald profil",
      "agents": {
        "kaila": {
          "name": "JUNO AI",
          "description": "Juridisk assistent"
        },
        "kfc": {
          "name": "JUNO AI för kommuner",
          "description": "Denna konversation är baserad på ärendebehandlarprofilen. Här används kommunens uppladdade dokument i svar."
        },
        "replay": {
          "name": "Återuppspelning",
          "description": "Spela upp tidigare konversationer"
        },
        "mock": {
          "name": "Mock",
          "description": "Simulerad agent"
        }
      }
    },
    "ask_kaila_back": {
      "submit_button": "Svar",
      "user_selected": "Jag har valt följande alternativ:",
      "mode_question": "Fråga",
      "mode_suggestion": "Förslag",
      "switch_mode": "Genomför djupgående forskning",
      "keep_previous_mode": "Behåll {{previous}}svaret",
      "about_deep": "Djupgående research kan ge dig ett mer fullständigt svar",
      "deep_description": "Djupgående research granskar lagstiftning, rättspraxis och relaterade källor innan du svarar, så att du kan få mer kontext och fler referenser.",
      "kfc_title": "Vilka områden bör jag fokusera på?",
      "kfc_description": "Jag har identifierat följande områden som kan vara relevanta för din fråga. Välj alla alternativ som är tillämpliga.",
      "skip": "Hoppa över"
    },
    "references_panel": {
      "empty_state": "Inga källor till detta svar.",
      "source_validation": {
        "button": "Visa",
        "toggle_type": "typ",
        "toggle_name": "titel"
      },
      "error": {
        "title": "Ett fel uppstod",
        "description": "Ett fel uppstod när källorna skulle laddas"
      },
      "go_to_document": "Gå till dokumentet",
      "header": "Källor",
      "no_content_disclaimer": "Förhandsvisning är inte tillgänglig",
      "open_in_karnov": "Öppna i Juno",
      "ai_generated_summary": {
        "text": "Sammanfattning av JUNO AI",
        "tooltip": "Rättspraxis sammanfattas av AI, för att ge ett snabbt överblik."
      }
    },
    "annotation_type": {
      "karnov": "Karnov lagkommentarer",
      "lexino": "Lexino",
      "nj_annotation": "NJ lagkommentarer"
    },
    "conversation_error": {
      "title": "Något gick fel",
      "description": "Något gick fel med konversationen. Försök att ladda om sidan eller kontakta kundservice.",
      "guide": "Hjälp oss att felsöka problemet genom att dela innehållet i konversationen.",
      "send_to_support": "Dela konversationen med oss",
      "success_title": "Felrapport skickad",
      "success_message": "Tack, din felrapport har skickats"
    },
    "conversation_feedback": {
      "cancel": "Hoppa över",
      "confirmation": "Tack för att du lämnat detaljerad feedback",
      "conversation_rating_question": "Kan du utveckla varför du valt detta? ",
      "description": "Välj den kategori som bäst passar din feedback. Detaljerad feedback gör det möjligt att förbättra JUNO AIs svar framöver. När du skickar in feedback ger du samtycke till att vi kan se din feedback, hela konversationen (frågor och svar), eventuella källor och bifogade filer.",
      "error": "Något gick fel, försök igen.",
      "feedback_modal": "Vi vill gärna ha din feedback",
      "consent_checkbox": "Jag samtycker till att bli kontaktad om ytterligare uppgifter behövs.",
      "options": {
        "1": {
          "title": "Föråldrad lagstiftning",
          "placeholder": "Svaret är baserat på upphävda rättskällor"
        },
        "2": {
          "title": "Hallucinationer (påhittat innehåll)",
          "placeholder": "Svaret innehåller påhittade referenser eller slutsatser utan giltiga rättskällor som stöd"
        },
        "3": {
          "title": "Saknar rättskällor",
          "placeholder": "Svaret saknar hänvisningar till relevanta rättskällor. Vänligen ange den eller de rättskällor som saknas"
        },
        "4": {
          "title": "Felaktig rättstillämpning",
          "placeholder": "Feltolkning / fel tillämpning av rättskällor"
        },
        "5": {
          "title": "Föråldrad information",
          "placeholder": "Svaret inkluderade inte de senaste rättskällorna, har således inte beaktat senaste rättsutvecklingen"
        },
        "6": {
          "title": "Annat",
          "placeholder": "Upplevde du andra problem med svaret? Meddela oss gärna"
        }
      },
      "submit": "Skicka detaljerad feedback",
      "textarea_placeholder": "Vänligen utveckla...",
      "title": "Tack för att du lämnar feedback"
    },
    "conversation_sources": "Källor",
    "prompt_templates": {
      "create_title": "Spara ny prompt",
      "create_description": "Spara promptar för senare bruk. Det kan vara användbart för uppgifter eller frågor som du ofta upprepar eller börjar på samma sätt.",
      "edit_title": "Redigera prompt",
      "title_label": "Namn",
      "title_placeholder": "",
      "content_label": "Din prompt",
      "content_placeholder": "",
      "save": "Spara",
      "cancel": "Avbryt",
      "delete": "Ta bort",
      "save_success": "Prompt sparad",
      "save_error": "Det gick inte att spara prompten",
      "validation_error": "Kontrollera namnet och prompten och försök igen",
      "delete_success": "Prompt borttagen",
      "delete_error": "Det gick inte att ta bort prompten",
      "delete_confirm": {
        "title": "Ta bort prompt",
        "question": "Är du säker på att du vill ta bort prompten?",
        "confirm": "Ta bort",
        "cancel": "Avbryt"
      },
      "title": "Sparade promptar",
      "description": "Om du märker att du ställer samma frågor eller återanvänder samma sammanhang om och om igen, kan du spara dina prompter här och använda dem på nytt med ett enda klick närhelst du behöver.",
      "new_prompt": "Ny prompt",
      "search_placeholder": "Sök bland promptar...",
      "search_aria": "Sök bland sparade promptar",
      "search_clear": "Rensa sökning",
      "see_details": "Visa detaljer",
      "close_details": "Dölj detaljer",
      "edit": "Redigera",
      "edit_prompt_aria": "Redigera promptar: {{title}}",
      "trigger_label": "Promptar",
      "trigger_tooltip": "Öppna sparade promptar",
      "no_results": "Inga resultat",
      "close": "Stäng sparade promptar",
      "delete_prompt_aria": "Ta bort prompt: {{title}}",
      "error": {
        "title": "Ett fel uppstod",
        "description": "Ett fel uppstod när sparade promptar skulle laddas"
      },
      "pagination": "Sidindelning",
      "pagination_previous": "Föregående",
      "pagination_next": "Nästa",
      "pagination_previous_aria": "Gå till föregående sida",
      "pagination_next_aria": "Gå till nästa sida",
      "pagination_page_aria": "Gå till sida {{page}}",
      "attachment_warning": "Uppladdade filer och referenser stöds ännu inte för sparade prompter.",
      "suggest": "Föreslå",
      "generating_title": "Genererar namn",
      "title_error": "Kunde inte skapa en namn"
    },
    "message_done_toast": "Din konversation är klar. Klicka här för att gå till konversationen",
    "message_done_toast_with_subject": "Din konversation \"{{subject}}\" är klar. Klicka här för att gå till konversationen",
    "error": {
      "no_access": {
        "description": "Välj en annan konversation eller starta en ny konversation i menyn",
        "title": "Du har inte tillgång till den här konversationen"
      },
      "not_found": {
        "description": "Välj en annan konversation eller starta en ny konversation i menyn",
        "title": "Konversationen hittades inte"
      },
      "unknown": {
        "description": "Försök att ladda om sidan",
        "title": "Din konversation kan inte laddas just nu"
      }
    },
    "message_action": {
      "cancel_edit_message": "Avbryt redigering",
      "copy_message": "Kopiera meddelande",
      "delete_failed_user_message": "Slet",
      "downvote_message": "Rösta ner meddelande",
      "upvote_message": "Rösta upp meddelande",
      "edit_message": "Redigera prompt",
      "edit": "Redigera",
      "export_docx": "Exportera till Word",
      "export": "Exportera",
      "more_actions": "Fler åtgärder",
      "print_message": "Skriv ut meddelande",
      "regenerate_message": "Skapa svar igen",
      "save_message": "Spara prompt",
      "save": "Spara",
      "skip_to_content": "Gå till innehållet",
      "to_top": "Till toppen"
    },
    "export_docx": {
      "success": "Dokument exporterat",
      "error": "Kunde inte exportera dokument",
      "question_heading": "Fråga",
      "answer_heading": "Svar"
    },
    "prompt_input": {
      "disclaimer_text": "JUNO AI använder kvalitetssäkrade juridiska källor, men kom ihåg att verifiera resultaten.",
      "disclaimer_link": {
        "prefix": "",
        "text": "",
        "suffix": "",
        "href": ""
      },
      "placeholder": "Skriv din fråga",
      "placeholder_follow_up": "Ställ en följdfråga",
      "document_tag": "Hänvisa till ett dokument"
    },
    "document_tagging": {
      "placeholder": "Skriv dokumentets namn här",
      "prompt_input_suggestion": "Hänvisa till ett dokument",
      "clear_input": "Rensa söktexten",
      "finding_documents": "Hittar dokument...",
      "search_for_documents_title": "Sök efter ett dokument från JUNO",
      "search_for_documents_description": "Ange ett dokuments titel eller referens",
      "no_documents_found_title": "Hittar inget dokument",
      "no_documents_found_description": "Skriv en giltig titel eller referens, eller gå till JUNO och hitta dokumentet.",
      "kfc_disclaimer": "JUNO AI har redan tillgång till dina lokala dokument, så de behöver inte taggas.",
      "error_title": "Något gick fel",
      "error_description": "Försök att ladda om sidan",
      "title": "Sökresultat"
    },
    "prompt_button": {
      "label": "Fråga JUNO AI",
      "stop": "Avbryt svaret"
    },
    "research_mode": {
      "light": {
        "name": "Snabbsökning",
        "short": "Snabb",
        "description": "För enklare frågor. Söker i ett begränsat urval av relevanta källor för ett snabbt svar."
      },
      "regular": {
        "name": "Standardsökning",
        "short": "Standard",
        "description": "För de flesta juridiska frågor. Söker brett i JUNO:s källor och ger ett strukturerat, väl underbyggt svar."
      },
      "deep": {
        "name": "Fördjupad sökning",
        "short": "Fördjupad",
        "description": "För komplexa frågor som kräver djupare analys. Söker mer omfattande och ger ett fördjupat svar. Tar längre tid."
      }
    },
    "user_message": {
      "cancel_button": "Avbryt",
      "submit_button": "Spara och Skicka in"
    },
    "table_view": {
      "close_button": "Stäng stor tabell",
      "modal_title": "Stor tabell",
      "open_button": "Öppna stor tabell"
    },
    "loading_header": {
      "estimated_time": "Beräknad väntetid",
      "less_than_a_minute": "Mindre än en minut",
      "minutes_one": "{{count}} minut",
      "minutes_other": "{{count}} minuter",
      "slow_answer_disclaimer": "Genererar ett komplext svar. Detta kan ta lite extra tid."
    },
    "clipboard": {
      "copy_success": "Innehållet kopierat",
      "copy_error": "Kopiering av innehåll misslyckades"
    }
  },
  "conversation_history": {
    "load_more_button": "Ladda mer",
    "load_more_title": "Visar sida {{currentPage}} av {{totalPages}}",
    "no_more_conversations": "Du har nått slutet av din konversationshistorik.",
    "go_to_top": "Gå till toppen av listan",
    "close_conversation_history_panel": "Gömma historik",
    "close_conversation_sidepanel": "Stäng sidepanel",
    "conversation_expiration_one": "{{count}} dag",
    "conversation_expiration_other": "{{count}} dagar",
    "conversation_expiration_tooltip_one": "Utlöper om 1 dag. Fäst konversationen eller ställ en följdfråga om du vill behålla den.",
    "conversation_expiration_tooltip_other": "Utlöper om {{count}} dagar. Fäst konversationen eller ställ en följdfråga om du vill behålla den.",
    "conversation_expiration_expired_tooltip": "Dina konversationer sparas i 90 dagar efter den senaste aktiviteten. Därefter raderas de automatiskt.",
    "conversation_action": {
      "delete": "Radera samtal",
      "pin": "Fästa",
      "rename": "Byt namn",
      "unpin": "Avfäst"
    },
    "conversation_delete_modal": {
      "cancel_button": "Avbryt",
      "delete_button": "Ta bort",
      "title": "Radera konversation",
      "question": "Är du säker på att du vill ta bort konversationen"
    },
    "error": {
      "description": "Försök att ladda om sidan",
      "title": "Din historik kan inte laddas just nu"
    },
    "expired_conversations_onboarding": "För att skydda din data kommer konversationer som varit inaktiva i mer än 90 dagar nu att raderas permanent.",
    "history": "Historik",
    "history_expiration_time": "90 dagar",
    "history_short": "Historik",
    "history_tooltip": "Dina konversationer sparas i 90 dagar efter den senaste aktiviteten. Därefter raderas de automatiskt.",
    "new_conversation_button": "Ny konversation",
    "new_conversation_button_short": "Ny",
    "new_conversation_subject": "Ny konversation",
    "new_document_analysis_button": "Dokumentanalys",
    "new_document_analysis_button_beta_label": "BETA",
    "new_document_analysis_button_new_label": "Nytt",
    "new_document_analysis_button_short": "Analys",
    "flow_access_link": "JUNO Flow",
    "flow_access_link_short": "Flow",
    "open_conversation_history_panel": "Visa historik",
    "open_conversation_sidepanel": "Öppna sidepanel",
    "panel_header": "Meny",
    "pinned": "Fäst",
    "edit_conversation_subject_submit": "Spara ändringar i konversationsämnet",
    "edit_conversation_subject_cancel": "Avbryt ändringar i konversationsämnet",
    "search_in_conversation": "Hitta konversation",
    "search_in_conversation_description": "Sök i konversationer efter ämne",
    "search_in_conversation_clear": "Rensa sökning",
    "empty_search_in_conversation": "Inga konversationer hittades med den sökningen: \"{{searchTerm}}\"",
    "toast_notification": {
      "conversation_pinned_error": "Konversationen kunde inte fästas",
      "conversation_unpinned_error": "Konversationen kunde inte tas bort",
      "conversation_pinned_successful": "Konversation fäst",
      "conversation_unpinned_successful": "Konversation avfäst",
      "conversation_delete_success": "Konversationen har raderats",
      "conversation_delete_error": "Konversationen kunde inte raderas",
      "subject_editting_error": "Ändring av rubrik misslyckades",
      "subject_editting_sucessful": "Konversationens rubrik har ändrats"
    },
    "today": "Idag",
    "yesterday": "Igår",
    "latest_7_days": "Senaste 7 dagarna",
    "latest_15_days": "Senaste 15 dagarna",
    "latest_30_days": "Senaste 30 dagarna",
    "latest_60_days": "Senaste 60 dagarna",
    "more_than_60_days": "Över 60 dagar - Löper snart ut",
    "expired": "Utlöper snart",
    "retention_info": "Dina aktiva konversationer sparas i 90 dagar. Därefter raderas de automatiskt för att skydda din integritet."
  },
  "file_upload": {
    "capacity_usage": "{{space}} % utrymme använt",
    "content_type": {
      "application/pdf": "Pdf",
      "application/msword": "Word",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "Word",
      "unknown": "Okänd",
      "unsupported": "Filtyp stöds inte"
    },
    "drag_and_drop_label_one": "Dra och släpp ditt dokument här",
    "drag_and_drop_label_other": "Dra och släpp dina dokument här",
    "file_upload_limit_exceeded": "Du har valt för många filer.",
    "file_upload_limit_reached": "Du kan inte ladda upp fler dokument.",
    "header": "Ladda upp ditt dokument för att komma igång",
    "subheader": "Kan vara Word (.docx) eller PDF",
    "upload_button": "Ladda upp dokument",
    "upload_status": {
      "error": "Fel",
      "uploading": "Laddar upp",
      "deleting": "Tar bort"
    },
    "error": {
      "above_page_count_limit": "Filerna får inte innehålla fler än 400 sidor.",
      "above_word_count_limit": "Filerna får inte innehålla fler än 100 000 ord",
      "above_file_size_limit": "Filerna får inte vara större än 20 MB.",
      "content_too_large": "Filerna får inte vara större än 20 MB.",
      "malformed_file_content": "Filen kunde inte läsas - den kan vara skadad",
      "deletion_error": "Ett fel uppstod när filen raderades.",
      "invalid_mime_type": "Den här filtypen stöds inte. Du kan bara ladda upp Word- (.docx) och PDF-filer.",
      "exceeds_token_limit": "Det här dokumentet överskrider utrymmesgränsen och kommer inte att användas.",
      "upload_error": "Ett fel inträffade vid uppladdning.",
      "virus_detected": "Den uppladdade filen verkar innehålla ett virus."
    }
  },
  "frequently_asked_questions": {
    "footer": {
      "customer_service": "Kundservice",
      "customer_service_url": "https://www.nj.se/kontakta-oss",
      "terms": "Allmänna villkor",
      "terms_url": "https://juno.nj.se/tos_acceptance"
    },
    "help": "Hjälp",
    "helpful_question_answer_title": "Svarade detta på din fråga?",
    "helpful_question_answer_button_yes": "Ja",
    "helpful_question_answer_button_no": "Nej",
    "thank_you_for_feedback_description": "Ditt input hjälper till att förbättra denna information för alla.",
    "thank_you_for_feedback_title": "Tack för din feedback!",
    "thank_you_for_feedback_toast_notification": "Tack för din feedback",
    "related_questions": "Relaterade frågor"
  },
  "help_and_feedback": {
    "button": "Hjälp & Feedback",
    "dropdown_options": {
      "help": "Hjälp",
      "tutorial": "Vägledning",
      "user_carousel_onboarding": "Onboarding"
    }
  },
  "kfc": {
    "description": "Det första svaret baseras på källor i JUNO, medan detta kompletterande svar baseras på din kommuns interna dokument, förutsatt att dessa är uppladdade och tillgängliga i JUNO för kommuner. Båda svaren innehåller referenser och länkar till de källor de baseras på."
  },
  "message": {
    "create_conversation_message_error": "Det gick inte att skicka.",
    "create_conversation_message_retry": "Försök igen",
    "streaming_waiting": "Väntar på svar",
    "streaming_canceled": "Svaret stoppades",
    "streaming_error": "Ett fel uppstod när svaret genererades",
    "streaming_error_retry": "Skapa svar igen",
    "streaming_error_code": "Felkod",
    "streaming_error_conversation": "Samtal",
    "streaming_reconnect_error": "Ett fel uppstod vid försök att återansluta",
    "streaming_reconnect_error_retry": "Försök att återansluta",
    "thoughts": "Reflektioner",
    "follow_up": "Du kanske också vill fråga",
    "follow_up_description": "Förslagen nedan hjälper dig att komma vidare i din konversation. Välj ett av förslagen och anpassa efter just din fråga för att fortsätta med konversationen.",
    "updated_at": "{{updatedAt, date}}"
  },
  "no_access": {
    "title": "Du har inte tillgång till detta innehåll",
    "description": "Detta innehåll kräver tillgång till en viss produkt eller ett visst abonnemang som inte ingår i ditt nuvarande abonnemang.",
    "refresh_access": {
      "button": "Uppdatera åtkomsten",
      "description": "Om du tror att det rör sig om ett misstag kan du prova att uppdatera dina åtkomstinställningar – detta synkroniserar din prenumeration och låser upp allt innehåll som är tillgängligt för dig.",
      "contact_support": "Om problemet kvarstår ber vi dig kontakta vår kundtjänst enligt uppgifterna nedan. De hjälper dig gärna."
    },
    "contact_info": {
      "header": "Vi är redo att hjälpa dig",
      "description": "Ring eller skriv till vår kundsupport och hör dig för om våra olika licenser",
      "link": {
        "prefix": "",
        "text": "",
        "suffix": "",
        "href": ""
      },
      "phone": "08-598 191 60",
      "email": "support@nj.se"
    }
  },
  "system_messages": {
    "_ANALYSING_DOCUMENTS_": "Analyserer dokument",
    "_ANALYSING_QUERY_": "Analyserar frågan",
    "_ANALYSING_SOURCES_": "Analyserar källorna",
    "_FETCHING_SIMILAR_DOCUMENTS_": "Hämtar liknande dokument",
    "_FETCHING_LAW_DOCUMENTS_": "Hämtar lagstiftning",
    "_FETCHING_PREPATORY_WORK_DOCUMENTS_": "Hämtar förarbeten",
    "_FETCHING_LITERATURE_DOCUMENTS_": "Hämtar litteratur",
    "_GENERATING_ANSWER_": "Skapar ett svar"
  },
  "document_tag_tooltip": "Klicka eller skriv ”@” för att referera till ett dokument",
  "input_character_limit_reached": "Maximalt antal tecken har uppnåtts",
  "user_carousels": {
    "dismiss": "Fortsätt",
    "carousels": {
      "onboarding": {
        "title": "Välkommen till JUNO AI",
        "read_more_url": "",
        "screens": {
          "welcome": {
            "description": "Kombinationen av vardagligt språk och vår AI-teknologi förenklar och stödjer ditt arbete.",
            "header": "Precision och nytta inom alla juridiska områden"
          },
          "credibility": {
            "description": "AI-teknikens styrkor förstärkta med mänskligt snille. Du har alltid sista ordet.",
            "header": "Kärnan är Norstedts Juridiks innehåll"
          },
          "security": {
            "description": "JUNO AI säkerställer säkerheten genom en strikt dataförvaltningsmodell.",
            "header": "Din information kommer alltid vara säker."
          },
          "feedback": {
            "description": "Det hjälper oss mycket om du kan ange din åsikt om de resultat du får.",
            "header": "Hjälp oss bli bättre genom feedback."
          }
        }
      }
    },
    "read_more_label": "Läs mer"
  },
  "header": {
    "goto_main_content": "Gå till huvudinnehållet"
  },
  "user_menu": {
    "logout": "Logga ut",
    "go_to_platform": "JUNO",
    "redirect_to_login": "Uppdatera åtkomst",
    "theme_selector": {
      "appearance": "Utseende",
      "theme": {
        "dark": "Mörk",
        "light": "Ljus",
        "system": "System"
      }
    },
    "language_selector": {
      "content": "innehåll",
      "header": "Språk",
      "languages": {
        "da": "Danska",
        "es": "Spanska",
        "fr": "Franska",
        "sv": "Svenska",
        "no": "Bokmål",
        "nn": "Nynorsk"
      }
    },
    "go_to_flow": "JUNO Flow",
    "learn_about_flow": "Läs mer om vår nya produkt",
    "badge": "Nytt"
  },
  "platform_name": "JUNO AI",
  "document_analysis": {
    "select_document_analysis_mode": "Välj ett analysalternativ",
    "hero_banner": {
      "intro": "Norstedts Juridik introducerar",
      "headline": "Dokumentanalys",
      "description": "Våra experter har utvecklat unika analysmöjligheter som hjälper dig att omvandla komplex juridik till konkreta lösningar."
    },
    "file_upload_header": {
      "description": "Ladda upp ditt kontrakt för att komma igång",
      "title": "Kontraktsgranskning"
    },
    "use_prompt_button": "Välj analys",
    "see_example_button": "Se exempel",
    "back_to_document_analysis_list": "Tillbaka till Dokumentanalysar",
    "options": {
      "contract_review": {
        "title": "Analysera kontrakt",
        "description": "Få en snabb, klausul-för-klausul-granskning av avtal som identifierar juridiska, ekonomiska och operativa risker samtidigt som den föreslår konkreta förbättringar. Resultatet är tydligt strukturerat och källförankrat, så att du kan gå från överblick till åtgärd på minuter. Perfekt för due diligence, upphandling och löpande avtalsgranskning​",
        "guide": "Utöver det uppladdade dokumentet kan du lägga till kompletterande uppgifter, t.ex. kontraktstyp och part, samt andra relevanta omständigheter som inte framgår av dokumentet.",
        "example_text": "Här visas ett exempel på en analys. Det ger en överblick över JUNO AIs svar så att du kan bedöma om det passar dina behov.” And for the button “Använd analys.",
        "placeholder": "Lägg till kompletterande uppgifter"
      },
      "document_compliance": {
        "title": "Kontrollera regelefterlevnad",
        "description": "Identifiera efterlevnadsbrister innan de blir problem. Du får en komplett rapport i tre steg – från exekutiv sammanfattning till en skarp gap- och riskmatris samt handfasta rekommendationer – som ger spårbarhet och beslutsunderlag för ledning och tillsyn. Särskilt lämpad för policyer, riktlinjer och interna kontroller.",
        "guide": "Utöver det uppladdade dokumentet kan du lägga till kompletterande uppgifter, t.ex. vilken part du är, eller andra relevanta omständigheter som inte framgår av dokumentet.",
        "example_text": "",
        "placeholder": "Lägg till kompletterande uppgifter"
      },
      "argument_strengthener": {
        "title": "Förstärk argumentation",
        "description": "Vänd analysen inåt och gör dina egna argument vattentäta. Tjänsten identifierar svagheter, förklarar deras konsekvenser och ger konkreta förstärkningsförslag – från att lägga till rättskällor till att justera struktur och bemöta invändningar. Resultatet: mer robusta PM, inlagor och beslutsunderlag på svenska med tydliga hänvisningar.",
        "guide": "Utöver det uppladdade dokumentet kan du lägga till kompletterande uppgifter, t.ex. vilken part du är, eller andra relevanta omständigheter som inte framgår av dokumentet.",
        "example_text": "",
        "placeholder": "Lägg till kompletterande uppgifter"
      },
      "weakness_finder": {
        "title": "Hitta svagheter",
        "description": "Avslöja brister i motpartens resonemang, källstöd och argumentation. Få en operativ plan med motauktoritet, angreppssätt och prioritering efter påverkan – redo att användas i förhandling, process eller strategisk analys. Höj träffsäkerheten och förkorta vägen till ett starkare förhandlingsläge.",
        "guide": "Utöver det uppladdade dokumentet kan du lägga till kompletterande uppgifter, t.ex. vilken part du är, eller andra relevanta omständigheter som inte framgår av dokumentet.",
        "example_text": "",
        "placeholder": "Lägg till kompletterande uppgifter"
      }
    }
  },
  "workspace_promo_banner": {
    "text": "Kom igång med att använda JUNO Flow för att utarbeta dokument",
    "link": "Läs mer",
    "badge": "Nytt"
  },
  "prompt_suggestions": {
    "kaila": {
      "title": "Vad vill du göra idag?",
      "description": "Låt dig inspireras av dessa förslag",
      "templates": [
        {
          "category": "siren-on",
          "prompt": "Hur avgörs om en fortkörning kan anses utgöra brottet vårdslöshet i trafik eller grov vårdslöshet i trafik?",
          "sample": "Jag behöver veta om fortkörning kan leda till fängelse?"
        },
        {
          "category": "square-info",
          "prompt": "Det framgår av vår anvisning för resor i tjänsten att det inte är tillåtet att uträtta privata ärenden eller ta med förvaltningens bilar hem. Undantag ska i förväg godkännas av närmaste chef. Det finns även beskrivet i rutinen att fordonen använder ISA och digital körjournal (positioneringsteknik), där datauttag kan komma att användas i individärenden om det finns misstanke om brott eller att medarbetare missbrukat arbetsgivarens förtroende. Om det visar sig att en anställd har använt tjänstefordonet för privatbruk, utgör det saklig grund för avsked?",
          "sample": "Jag behöver utreda om privat bruk av tjänstebil utgör grund för avsked?"
        },
        {
          "category": "file-lines",
          "prompt": "Beskriv de centrala delarna av legalitetsprincipen",
          "sample": "Vilka är de centrala delarna av legalitetsprincipen?"
        },
        {
          "category": "list",
          "prompt": "Kan du ge mig en lista på nödvändiga delar i en miljökonsekvensbeskrivning?",
          "sample": "Skapa en lista över de viktigaste delarna av en miljökonsekvensbeskrivning"
        }
      ]
    },
    "kfc": {
      "title": "Vad vill du göra idag?",
      "description": "Låt dig inspireras av dessa förslag",
      "templates": [
        {
          "category": "book-section",
          "prompt": "Kan äldre syskon hämta sina yngre syskon från förskola? Vem har ansvaret om vårdnadshavare har lämnat sitt godkännande?",
          "sample": "Kan äldre syskon hämta sina yngre syskon från förskola? Vem har ansvaret om vårdnadshavare har lämnat sitt godkännande?"
        },
        {
          "category": "book-section",
          "prompt": "Är ett helägt kommunalt bolag är att betrakta som offentlig kund?",
          "sample": "Är ett helägt kommunalt bolag är att betrakta som offentlig kund?"
        },
        {
          "category": "book-section",
          "prompt": "Är dokumentation i rekryteringsprocess allmänna handlingar?",
          "sample": "Är dokumentation i rekryteringsprocess allmänna handlingar?"
        },
        {
          "category": "book-section",
          "prompt": "Har man rätt att få hemtjänst i annan kommun under en månads semestervistelse?",
          "sample": "Har man rätt att få hemtjänst i annan kommun under en månads semestervistelse?"
        }
      ]
    },
    "replay": {
      "title": "Vad vill du göra idag?",
      "description": "Låt dig inspireras av dessa förslag",
      "templates": [
        {
          "category": "scale-unbalanced-flip",
          "prompt": "example",
          "sample": "Example"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "error",
          "sample": "Error"
        }
      ]
    },
    "mock": {
      "title": "Vad vill du göra idag?",
      "description": "Låt dig inspireras av dessa förslag",
      "templates": [
        {
          "category": "scale-unbalanced-flip",
          "prompt": "test",
          "sample": "test"
        },
        {
          "category": "book-section",
          "prompt": "gfm",
          "sample": "Git flavoured markdown"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "invalid",
          "sample": "Invalid response"
        },
        {
          "category": "book-section",
          "prompt": "markdown",
          "sample": "markdown"
        },
        {
          "category": "siren-on",
          "prompt": "markdown-invalid",
          "sample": "Invalid & malformed markdown"
        },
        {
          "category": "siren-on",
          "prompt": "markdown-error",
          "sample": "Component that throws an uncaught exception"
        },
        {
          "category": "table",
          "prompt": "table",
          "sample": "table"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "details",
          "sample": "details"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "stressTest",
          "sample": "stress test"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "markdownAndInlineReferences",
          "sample": "Inline references after markdown elements"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "refsList",
          "sample": "Inline references in list"
        },
        {
          "category": "book-section",
          "prompt": "new-refsList",
          "sample": "New reference mdx format"
        }
      ]
    }
  },
  "errors": {
    "footer": {
      "title": "Vi är redo att hjälpa till",
      "description": "Har du stött på problem kontakta kundtjänst på {{telephone}} eller {{email}}",
      "email": "support@nj.se",
      "telephone": "08-598 191 60"
    },
    "auth": {
      "no_session": {
        "title": "",
        "subtitle": "",
        "description": ""
      },
      "default": {
        "title": "Vi kunde inte logga in dig",
        "subtitle": "",
        "description": "Ett fel uppstod vid inloggningen. Vänligen försök igen eller kontakta kundtjänst om problemet kvarstår."
      }
    }
  },
  "close_service_message_banner": "Stäng meddelande",
  "upload_modal": {
    "attachment_limit_exceeded_warning": "Du har nått gränsen på {{attachmentLimit}} dokument per fråga. Ta bort ett dokument innan du laddar upp ett till.",
    "close_modal_button_label": "Färdig",
    "description": "Du kan ladda upp som mest {{attachmentLimit}} dokument, men antalet beror på deras storlek.",
    "done_button": "Färdig",
    "file_browser": {
      "browse_files": "Bläddra",
      "description": "Filtyper som stöds: .pdf och .docx",
      "header": "Klicka här för att ladda upp, eller dra och släpp"
    },
    "capacity_indicator": {
      "attachment_count": "{{count}}/{{limit}} Dokument",
      "tooltip": "Varje dokument upptar en procentandel av din totala uppladdningsgräns, baserat på antal ord – inte filstorlek. Långa dokument tar därför mer plats, så du kan nå 100 % innan du har laddat upp 10 filer",
      "used_capacity": "använt utrymme"
    },
    "file_upload_button_tooltip": "Ladda upp filer",
    "header": "Ladda upp filer",
    "open_modal_button": "Ladda upp filer",
    "onboarding_tooltip": "Nytt: ladda upp 10 dokument per prompt",
    "reinsurance_label": "Dina filer är krypterade",
    "reinsurance_tooltip": "Karnov Group skyddar konfidentialiteten för all kunddata, inklusive användarinmatningar, genererad data och dokument, med hjälp av stark kryptering som uppfyller tillämpliga standarder."
  },
  "prompt_input_with_document_references": {
    "add_document_references_button": {
      "label": "Referera till dokument",
      "tooltip": "Klicka för att referera till ett dokument",
      "onboarding_tooltip": "Vi har gjort det enklare att hänvisa till dokument."
    }
  },
  "document_references_modal": {
    "description": "Genom att referera till dokument kan du få ett mer precist svar",
    "close_modal_button_label": "Klar",
    "document_references_count": "Valda hänvisningar ({{count}})",
    "done_button": "Klar",
    "empty_state": {
      "header": "Inkludera en källa i svaret",
      "description": "Du kan använda den här funktionen om du vill vara säker på att en eller flera källor inkluderas i svaret från JUNO AI."
    },
    "header": "Referera till dokument",
    "remove_document_reference_button": "Ta bort referens",
    "search": {
      "fetching_suggestions": "Hämtar dokument...",
      "input_label": "Sök efter ett dokument",
      "input_placeholder": "Skriv dokumentets namn här",
      "error": {
        "description": "Försök att ladda om sidan",
        "title": "Något gick fel"
      },
      "empty_search": {
        "description": "Skriv en giltig titel eller referens, eller gå till JUNO och hitta dokumentet.",
        "kfc_disclaimer": "JUNO AI har redan tillgång till dina lokala dokument, så de behöver inte taggas.",
        "title": "Inga dokument hittades"
      }
    }
  },
  "message_resources": {
    "remove_message_resource": {
      "attachment": "Ta bort dokument",
      "document_reference": "Ta bort referens"
    },
    "open_modal": {
      "attachment": "Visa dokument",
      "document_reference": "Visa referenser"
    },
    "placeholder": {
      "label": {
        "attachment": "{{count}} uppladdade filer",
        "document_reference": "{{count}} dokument som hänvisats till"
      },
      "tooltip": {
        "attachment": "Visa alla uppladdade filer",
        "document_reference": "Visa alla dokument som det hänvisas till"
      }
    }
  },
  "search": {
    "clear_input": "Rensa söktext",
    "placeholder": "Söka..." 
  }
}
